export const COMMON_TEXT_ADMIN = {
    TAB: {
        TEAM_MEMBERS: 'Команда',
        PROGRAMS: 'Програми',
    },

    ALT: {
        DELETE: 'Видалити',
        UPLOAD: 'Завантажити',
        SCROLL_TO_TOP: 'Прокрутити вгору',
        NOT_FOUND: 'Не знайдено',
        EXPAND_OPTIONS_LIST: 'Відкрити список опцій',
        COLLAPSE_OPTIONS_LIST: 'Закрити список опцій',
        OPTION_SELECTED: 'Опцію вибрано',
        OPTION_NOT_SELECTED: 'Опцію не вибрано',
        SHOW_TOOLTIP: 'Показати підказку',
        HIDE_TOOLTIP: 'ховати підказку',
        HINT: 'Підказка',
        OPEN_MENU: 'Відкрити меню',
        CLOSE_MENU: 'Закрити меню',
        IMAGE_PREVIEW: "Прев'ю зображення",
    },

    INPUT: {
        PHOTO_PLACEHOLDER: 'Перетягніть файл сюди або натисніть для завантаження',
    },

    STATUS: {
        DEFAULT: 'Статус',
        DRAFT: 'Чернетка',
        PUBLISHED: 'Опубліковано',
    },

    TOOLTIP: {
        PUBLISHED_IN: 'Опубліковано в:',
        DRAFTED_IN: 'Збережено в:',
    },

    LIST: {
        NOT_FOUND: 'Нічого не знайдено',
    },

    FILTER: {
        SEARCH_BY_NAME: 'Пошук за назвою',
        STATUS: {
            ALL: 'Усі',
            PUBLISHED: 'Опубліковано',
            DRAFT: 'Чернетка',
        },
        CATEGORY: {
            CATEGORY_LABEL: 'Категорія',
            SELECT_CATEGORY: 'Виберіть категорію',
        },
    },

    QUESTION: {
        SAVE_CHANGES: 'Зберегти зміни?',
        CHANGES_WILL_BE_LOST_WISH_TO_CONTINUE: 'Зміни будуть втрачені. Бажаєте продовжити?',
        REMOVE_FROM_PUBLICATION: 'Зняти з публікації?',
        PUBLISH_CHANGES: 'Опублікувати зміни?',
    },

    BUTTON: {
        YES: 'Так',
        NO: 'Ні',
        SAVE: 'Зберегти',
        DELETE: 'Видалити',
        CANCEL: 'Відмінити',
        SAVE_AS_DRAFT: 'Зберегти як чернетку',
        SAVE_AS_PUBLISHED: 'Опублікувати',
        TRY_AGAIN: 'Спробувати ще раз',
    },
};
